import { render, staticRenderFns } from "./tjhclb.vue?vue&type=template&id=1b704a37&scoped=true&"
import script from "./tjhclb.vue?vue&type=script&lang=js&"
export * from "./tjhclb.vue?vue&type=script&lang=js&"
import style0 from "./tjhclb.vue?vue&type=style&index=0&id=1b704a37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b704a37",
  null
  
)

export default component.exports